import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useNavigate, Link } from 'react-router-dom';
import { Shield, Lock, Mail, Key, Layout } from 'lucide-react';

const SuperAdminLogin = () => {
    const [formData, setFormData] = useState({ email: '', password: '', token: '' });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const { superAdminLogin } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            await superAdminLogin(formData.email, formData.password, formData.token);
            navigate('/app/admin');
        } catch (err) {
            setError(err.message || 'Giriş başarısız.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{
            minHeight: '100vh',
            background: '#1a120b',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontFamily: 'Inter, sans-serif'
        }}>
            <div style={{ maxWidth: '400px', width: '90%' }}>
                <div style={{ textAlign: 'center', marginBottom: '2.5rem' }}>
                    <div style={{
                        width: '64px',
                        height: '64px',
                        background: 'rgba(166, 123, 91, 0.1)',
                        color: '#a67b5b',
                        borderRadius: '16px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '0 auto 1.5rem',
                        border: '1px solid rgba(166, 123, 91, 0.2)'
                    }}>
                        <Shield size={32} />
                    </div>
                    <h1 style={{ color: 'white', fontSize: '1.75rem', fontWeight: 800, marginBottom: '0.5rem' }}>System Administration</h1>
                    <p style={{ color: '#a1887f', fontSize: '0.875rem' }}>Restricted access for global administrative operations.</p>
                </div>

                <div className="card" style={{ background: '#2d2013', border: '1px solid #3e2723', padding: '2.5rem' }}>
                    {error && (
                        <div style={{
                            background: 'rgba(239, 68, 68, 0.1)',
                            border: '1px solid rgba(239, 68, 68, 0.2)',
                            color: '#f87171',
                            padding: '1rem',
                            borderRadius: '12px',
                            marginBottom: '1.5rem',
                            fontSize: '0.875rem'
                        }}>
                            {error}
                        </div>
                    )}

                    <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
                        <div>
                            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#d7ccc8', fontSize: '0.8125rem', fontWeight: 600, marginBottom: '0.5rem' }}>
                                <Mail size={14} /> E-mail
                            </label>
                            <input
                                required
                                type="email"
                                value={formData.email}
                                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                                style={{ width: '100%', background: '#1a120b', border: '1px solid #3e2723', color: 'white' }}
                                placeholder="admin@premiumcrm.com"
                            />
                        </div>

                        <div>
                            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#d7ccc8', fontSize: '0.8125rem', fontWeight: 600, marginBottom: '0.5rem' }}>
                                <Lock size={14} /> Password
                            </label>
                            <input
                                required
                                type="password"
                                value={formData.password}
                                onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                                style={{ width: '100%', background: '#1a120b', border: '1px solid #3e2723', color: 'white' }}
                                placeholder="••••••••"
                            />
                        </div>

                        <div style={{ padding: '1rem', background: 'rgba(166, 123, 91, 0.05)', borderRadius: '12px', border: '1px dashed rgba(166, 123, 91, 0.3)' }}>
                            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#a67b5b', fontSize: '0.8125rem', fontWeight: 700, marginBottom: '0.5rem' }}>
                                <Key size={14} /> Security Token
                            </label>
                            <input
                                required
                                type="text"
                                value={formData.token}
                                onChange={(e) => setFormData({ ...formData, token: e.target.value })}
                                style={{ width: '100%', background: '#1a120b', border: '1px solid #3e2723', color: 'white' }}
                                placeholder="XXXX-XXXX-XXXX"
                            />
                            <p style={{ color: '#8d6e63', fontSize: '0.75rem', marginTop: '0.5rem' }}>The unique hardware-bound authentication token.</p>
                        </div>

                        <button
                            type="submit"
                            disabled={loading}
                            style={{
                                background: '#a67b5b',
                                color: '#1a120b',
                                fontWeight: 700,
                                padding: '0.875rem',
                                marginTop: '1rem',
                                border: 'none'
                            }}
                        >
                            {loading ? 'Authenticating...' : 'Authorize Access'}
                        </button>
                    </form>
                </div>

                <div style={{ textAlign: 'center', marginTop: '2rem' }}>
                    <Link to="/" style={{ color: '#64748b', fontSize: '0.875rem', textDecoration: 'none' }}>Back to Main Site</Link>
                </div>
            </div>
        </div>
    );
};

export default SuperAdminLogin;
